import { render, staticRenderFns } from "./BkashPromotionCreate.vue?vue&type=template&id=08e2fce0&scoped=true&"
import script from "./BkashPromotionCreate.vue?vue&type=script&lang=js&"
export * from "./BkashPromotionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2fce0",
  null
  
)

export default component.exports